import React from 'react';
import PropTypes from 'prop-types';


import * as styleUtils from '../../../utils/styleUtils';

import styles from './GridLoader.scss';


function GridLoader({gridClassName, tileClassName, tileCount, tilesPerRow}) {

    const tiles = [];
    for (let i = 0; i < tileCount; i++) {
        tiles.push({});
    }

    const colNumber = Math.ceil(12 / tilesPerRow);

    return (
        <div className={styleUtils.toClasses(styles.gridLoader, gridClassName, 'grid-gutter-x-standard', 'row')}>

            {tiles.map(({}, i) => (
                <div
                    className={styleUtils.toClasses(styles.tile, `col-${colNumber}`, tileClassName)}
                    key={`gridLoaderTile${i}`}
                >
                    &nbsp;
                </div>
            ))}

        </div>
    );
}


GridLoader.propTypes = {
    gridClassName: PropTypes.string,
    tileClassName: PropTypes.string,
    tileCount: PropTypes.number.isRequired,
    tilesPerRow: PropTypes.number.isRequired
};


GridLoader.defaultProps = {
    tileCount: 6,
    tilesPerRow: 3
};


export default GridLoader;
